export default {
  default: () => import("/workspace/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/workspace/layouts/empty.vue").then(m => m.default || m),
  settings: () => import("/workspace/layouts/settings.vue").then(m => m.default || m)
}